<template>
  <div style='padding:15px;'>
    <div @click="$router.go(-1)" style="cursor:pointer; float:right;"><i class="fas fa-arrow-circle-left fa-2x" style="color:deepskyblue;"></i></div>
    <div class="statusPropale">
      <div>
        <p>Statut du devis : {{ propale.statut_libelle }}</p>
      </div>
      <div>
        <p>Nom du fichier : {{ nameFile }} <a v-on:click.stop="visualDevisTiers(propale)"><span style="cursor:pointer;" class='far fa-eye' v-b-tooltip.hover title='Visualiser'></span></a></p>
      </div>
      <div>
        <el-button type="primary">Valider le devis</el-button>
      </div>
    </div>
    <b-tabs lazy content-class="mt-3">
      <b-tab title="En-tête" active name="header">
        <HeaderDevis v-bind:socid="this.$route.params.idTiers" v-bind:idPropale="this.$route.params.idPropale" />
      </b-tab>
      <b-tab title="Contenu" name="content">
        <ContentDevis v-bind:socid="this.$route.params.idTiers" v-bind:idPropale="this.$route.params.idPropale" />
      </b-tab>
      <b-tab title="Contact/Adresses" name="contact">Contact/Adresses</b-tab>
      <b-tab title="Modèle de document" name="modele">Modèle de document</b-tab>
      <b-tab title="Coefficient" name="coefficient">Coefficient</b-tab>
      <b-tab title="Ouvrages" name="ouvrages">Ouvrages</b-tab>
      <b-tab title="Modification en masse" name="masse">Modification en masse</b-tab>
      <b-tab title="Notes" name="notes">Notes</b-tab>
      <b-tab title="Fichiers joints" name="fichiers">Fichiers joints</b-tab>
      <b-tab title="Suivi" name="suivi">Suivi</b-tab>
    </b-tabs>
    <!------------------------------------------------------- Affichage devis modal ---------------------------------------------------------------------------------->
    <b-modal id="modalVisualDevisTiers" :title="modal.title" hide-footer>
        <template>
            <iframe id="visualDoc" v-bind:src="modal.src"></iframe>
        </template>
    </b-modal>
    <!------------------------------------------------------- Fin affichage devis modal ---------------------------------------------------------------------------------->
  </div>  
</template>

<script>
import script from '../../../../script/script.js'
import scriptTiers from '../../../../script/script_tiers.js'
import scriptPropale from '../../../../script/script_propale.js'
import HeaderDevis from './HeaderDevis'
import ContentDevis from './ContentDevis'
var moment = require('moment');
function initialState (){
  return {
    activeName:"header",
  }
}
export default {
  props: {
  },
  data () {
    return initialState()
  },
  methods: {
    resetData(){
      Object.assign(this.$data, initialState())
    },
    detailsTiers: scriptTiers.detailsTiers,
    loadingClient: scriptTiers.loadingClient,
    loadPropale: scriptPropale.loadPropale,
    async verifyTiers () {
      await this.loadPropale(this.$route.params.idPropale)
      if(this.$route.params.idTiers!=null){
        this.detailsTiers(this.$route.params.idTiers)
      }else{
        this.loadingClient()
      }
    },
    visualDevisTiers: scriptTiers.visualDevisTiers,
  },
  watch: {
  },
  mounted: function () {
    this.verifyTiers()
  },
  components: {
    HeaderDevis,
    ContentDevis
  },
  computed:{
    infosTiers(){
      return this.$store.state.infoSoc
    },
    modal(){
      return this.$store.state.modalDoc
    },
    propale(){
      return this.$store.state.currentPropale
    },
    nameFile(){
      let reg=new RegExp("[/]+", "g")
      let tab = this.propale.last_main_doc.split(reg)
      return tab[2]
    },
  }
}
</script>

<style scoped>
#infoDevis{
  flex: 1 1 45%;
  margin-right: 5%;
}

#infoProduit{
  flex: 1 1 45%;
}

.menuPropale{
  width: 95%;
}

#tableProduct >>> .descriptionProduct{
  width: 20em;
  max-width: 20em;
}

#tableProduct >>> .prixProduct{
  width: 8em;
  max-width: 8em;
}

#tableProduct >>> .tvaProduct{
  width: 6em;
  max-width: 6em;
}

#tableProduct >>> .qtyProduct{
  width: 8em;
  max-width: 8em;
}

#tableProduct >>> .reducProduct{
  width: 6em;
  max-width: 6em;
}

#selectType{
  margin-bottom: 1em;
}

#selectTypeLine{
  margin-bottom: 1em;
}

#formPropal{
  display: flex;
}

.actionBarPropal{
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  text-align: end;
  padding: 1em;
  background: white;
}

.headerPropale{
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.headerPropale p{
  margin: 0;
}

.infosTiers{
  flex: 0 0 20%;
}

.recapPropale{
  flex: 0 0 70%;
}

.statusPropale{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
}

.statusPropale > div{
    padding: 1em;
}

.statusPropale > div > p{
    margin: 0;
}

.searchProduct{
}

.searchProduct .el-autocomplete{
  width: 400px;
}

.freeProduct,.headerFreeProduct,.searchProduct{
  padding-bottom: 1em;
  padding-top: 1em;
}

.fonctSupp{
  padding-bottom: .5em;
}

.addProduct{
  padding-bottom: 1em;
}

.dateServiceProduct{
  width: 100%;
}

.fonctProduct{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: space-between;
}

.listProduct .table tr:nth-child(even) {
  background-color: #f2f2f2;
}

#modalLine .modalLineToAdd{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-around;
  align-items: center;
}

#modalLine #formAddLine{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: flex-end;
}

#modalTitle #formTitleToAdd{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: flex-end;
}
</style>
<style>
#modalLine .modal-dialog.modal-md{
  max-width: 70%;
}

.productPopover{
  height: 300px;
  overflow: auto;
}
</style>